import React, { useState, useEffect } from 'react';
import Portfolio from './Portfolio';
import ProfessionalView from './components/professional/ProfessionalView';
import ViewToggle from './components/ViewToggle';
import './styles/app.css';

const STORAGE_KEY = 'portfolioView';
const DEFAULT_VIEW = 'professional';

const getInitialView = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'professional' || saved === 'terminal') return saved;
  } catch (e) { /* localStorage unavailable */ }
  return DEFAULT_VIEW;
};

const App = () => {
  const [view, setView] = useState(getInitialView);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, view); } catch (e) { /* ignore */ }
    document.body.classList.toggle('pro-view', view === 'professional');
    document.body.classList.toggle('terminal-view', view === 'terminal');
    // Jump to top when switching views so the user lands at the hero/header.
    window.scrollTo(0, 0);
    if (document.getElementById('root')) document.getElementById('root').scrollTo(0, 0);
  }, [view]);

  return (
    <>
      {view === 'terminal' ? <Portfolio /> : <ProfessionalView />}
      <ViewToggle view={view} onChange={setView} />
    </>
  );
};

export default App;
